import BaseService from '@/services/services/tools/baseService';
import LogbooksAPI from '@/services/api/internal/logbooks.api';
import Client from '@/services/api/internal/tools/client';
import {
  errorHandler,
  treatsCurrent,
} from '@/business/apiTreatment/response/baseAPITreatment';

const treatsEntry = (entry) => {
  return {
    ...treatsCurrent({
      datetimeFieldNames: ['entry_datetime'],
      JSONFieldNames: ['payload'],
    })(entry),
    entries: entry.entries ? entry.entries.map(treatsEntry) : [],
  };
};
/**
 * Business function. Treats entries from API.
 * @param {object} response The response of the API
 * @returns {object} The response treated.
 */
export const treatsEntries = (response) =>
  response.data.items && response.data.items.map(treatsEntry);

export function getLogbookEntriesNumber(idx) {
  const url = `${process.env.MYPREDITY_BASE_URI}/properties/logbook_entries`;
  return Client.post(url, { properties: idx })
    .then((response) => response.data.logbook_entries)
    .catch(errorHandler);
}

const LogbooksService = new BaseService({
  api: LogbooksAPI,
  treatListResponse: treatsEntries,
  treatCurrentResponse: (res) => treatsEntry(res.data.items[0]),
  urlParamsItems: { expand: 'entries' },
  urlParamsCurrent: { expand: 'entries' },
});

export default LogbooksService;
